import {
  List as ImmutableList,
} from 'immutable';

import Filter from '../../../modules/filter/Filter';
import {FACET_IDS} from './facetConstants';

class Facet {
  static fromRawCategory(rawCategory) {
    const rawCategoryMap = [
      {
        id: rawCategory.categoryId,
        name: rawCategory.categoryName,
        itemsCount: rawCategory.itemsCount,
        categoryId: rawCategory.categoryId,
        category: rawCategory,
        mordorId: rawCategory.mordorId,
      },
    ];

    const items = rawCategory.parents
      ? rawCategory.parents.map(rawParentCategory => ({
        id: rawParentCategory.categoryId,
        name: rawParentCategory.categoryName,
        itemsCount: rawParentCategory.itemsCount,
        categoryId: rawParentCategory.categoryId,
        mordorId: rawParentCategory.mordorId,
        category: rawParentCategory,
      })).concat(rawCategoryMap)
      : rawCategoryMap;

    const siblingItems = rawCategory &&
      rawCategory.children &&
      rawCategory.children.length &&
      rawCategory.children.length === 0 &&
      rawCategory.siblings.map(
        rawSiblingCategory => ({
          id: rawSiblingCategory.categoryId,
          name: rawSiblingCategory.categoryName,
          itemsCount: rawSiblingCategory.itemsCount,
          categoryId: rawSiblingCategory.categoryId,
          mordorId: rawSiblingCategory.mordorId,
          category: rawSiblingCategory,
        })
      );

    const result = new Facet({
      id: FACET_IDS.CATEGORY,
      title: 'Kategori',
      items,
      childItems: rawCategory && rawCategory.children && rawCategory.children.map(
        rawChildCategory => ({
          id: rawChildCategory.categoryId,
          name: rawChildCategory.categoryName,
          itemsCount: rawChildCategory.itemsCount,
          categoryId: rawChildCategory.categoryId,
          mordorId: rawChildCategory.mordorId,
          category: rawChildCategory,
        })
      ),
      siblingItems,
      mordorId : rawCategory.mordorId,
      hasMoreItem: false,
      isSorted: false,
      totalItemCount: rawCategory.itemsCount,
      isIndexable: false,
      categoryId: rawCategory.categoryId,
    });

    return result;
  }

  static fromPojo(pojo) {
    return {
      ...pojo,
    };
  }

  static fromRawAppliedFacet(rawAppliedFacet) {
    return new Facet({
      ...rawAppliedFacet,
      items: rawAppliedFacet.items.map(item =>
        Filter.fromRawAppliedFilter(item, rawAppliedFacet),
      ),
    });
  }

  constructor(rawFacet = {}) {
    this.id = rawFacet.id;
    this.title = rawFacet.title;
    this.filterList = ImmutableList(
      rawFacet.items.map(
        rawFilter => new Filter(rawFilter)
      )
    );
    this.visibleFilterList = ImmutableList(
      (rawFacet.visibleItems || rawFacet.items).map(
        rawFilter =>
          new Filter(rawFilter)

      )
    );
    this.childFilterList = ImmutableList(
      (rawFacet.childItems || []).map(
        rawFilter =>
          new Filter(rawFilter)

      ));
    this.siblingFilterList = ImmutableList(
      (rawFacet.siblingItems || []).map(
        rawFilter =>
          new Filter(rawFilter)

      ));
    this.hasMoreItem = rawFacet.hasMoreItem;
    this.isSorted = rawFacet.isSorted;
    this.totalItemCount = rawFacet.totalItemCount;
    this.isIndexable = rawFacet.isIndexable;
    this.isIndexableWithBrandFilter = rawFacet.isIndexableWithBrandFilter;
    this.filterDisplayType = rawFacet.filterDisplayType;
    this.categoryId = rawFacet.categoryId || null;
    this.customFacetId = rawFacet.customFacetId || rawFacet.mordorId;
    this.mordorId = rawFacet.mordorId;
    this.enabled = rawFacet.enabled;
    this.rawFacet = rawFacet;
  }

  hashCode() {
    return parseInt(this.id, 10);
  }

  equals(facet) {
    return (
      facet.id === this.id &&
      facet.filterList !== this.filterList &&
      facet.visibleFilterList !== this.visibleFilterList
    );
  }
}

export default Facet
